import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

export default async function getUnviewedNotificationsCount() {
  const response = await institutionAPI({
    method: 'POST',
    url: '/notification/notification/notification/count-unread',
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
